import axios from "axios";
import React, { useEffect, useState } from "react";

interface NewsStructure {
  id:string;
  title:string;
  img:string;
  desc:string;
  date:string;
}


const relatedNews = [
  {
    id: 1,
    title: "WARFARE IN THE AGE OF EMOTION AND DECEPTION",
    image: "src/images/business1.webp",
  },
  {
    id: 2,
    title: "UKRAINIAN DRONE STRIKES SHATTER",
    image: "src/images/business2.webp",
  },
  {
    id: 3,
    title: "NaMo VOICE OF UNITY",
    image: "src/images/business3.webp",
  },
  {
    id: 4,
    title: "CHIRAG THE DARK HORSE IN BIHAR POLLS?",
    image: "src/images/business4.webp",
  },
  {
    id: 5,
    title: "Climate Change will be most impactful risk facing worldwide in coming times",
    image: "src/images/business5.webp",
  },
  {
    id: 6,
    title: "WHAT IPL-2025 CAN TEACH EQUITY INVESTORS ABOUT PORTFOLIO MANAGEMENT",
    image: "src/images/business6.webp",
  },
  {
    id: 7,
    title: "THE PATH TO UNCONDITIONAL LOVE",
    image: "src/images/newslist2-1.webp",
  },
  {
    id: 8,
    title: "TRUMP’S GLOBAL TRADE PLANS ARE IN DISSARAY",
    image: "src/images/newslist2-2.webp",
  },
  {
    id: 9,
    title: "‘UNSTOPPABLE’ RISE UNDER MODI",
    image: "src/images/newslist2-3.webp",
  },
];

const RelatedNews = () => {
   const api = process.env.REACT_APP_API_URL as string;
      const [newData, setNewData] = useState<NewsStructure[]>([]);
  
      
        useEffect(() => {
          const fetchData = async () => {
            try {
              const response = await axios.get<NewsStructure[]>(
                `${api}/auth/news`
              );
      
              //console.log('news data',response.data)
              setNewData(response.data);
              //console.log("news data in a array",newData);
            } catch (error) {
              console.error("Post Not Found:", error);
            }
          };
      
          fetchData();
        }, []);
  return (
    <div className="px-4 py-6">
      <h2 className="text-2xl font-bold text-black mb-6 border-b-2">
        RELATED NEWS <span className="text-red-600">&gt;</span>
      </h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        {newData.map((news) => (
          <div key={news.id} className="cursor-pointer" onClick={()=>{
            window.location.href = `/news/${news.id}`
          }}>
            <img
              src={`${api}/${news.img}`}
              alt={news.title}
              className="w-full h-52 sm:h-56 md:h-60 object-cover rounded-md shadow-md"
            />
            <p className="mt-2 text-base sm:text-xl font-bold text-gray-900 leading-tight">
              {news.title}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RelatedNews;
